'use client';

import { DAppProvider } from '@usedapp/core';
import { RPC_URL } from 'lib/constants';

const config = {
  readOnlyChainId: 159,
  readOnlyUrls: {
    '159': RPC_URL,
  },
  pollingInterval: 50000,
};

export const DAppWrapper = ({ children }: { children: React.ReactNode }) => {

  return (
    <DAppProvider config={ config }>{ children }</DAppProvider>
  );

};
